import { Injectable } from '@angular/core'
import { ProfileResponse } from 'src/app/models/profile-response.model'
import { environment } from 'src/environments/environment'

const PRETTY_URL_REGEX = /.*investor\.vanguard\.com.*/
const ETF_REGEX = /.*investment-products\/etfs.*/
const MF_REGEX = /.*investment-products\/mutual-funds.*/
const PLAN529_REGEX = /.*accounts-plans\/529-plans.*/
@Injectable({
  providedIn: 'root',
})
export class FundUtilityService {
  // eslint-disable-next-line complexity
  routeToPrettyUrl(response: ProfileResponse, url: string) {
    const { isETF, isMutualFund, is529, ticker, fundId } = response.fundProfile
    const secYieldPath = url.includes('sec-yield') ? '/sec-yield' : ''

    let path = ''
    let id = ''

    if (this.isInvalidEtf(isETF, url)) {
      path = 'investment-products/etfs/profile'
      id = ticker.toLowerCase()
    } else if (this.isInvalidMf(isMutualFund, url)) {
      path = 'investment-products/mutual-funds/profile'
      id = ticker.toLowerCase()
    } else if (this.isInvalid529(is529, url)) {
      path = 'accounts-plans/529-plans/profile'
      id = fundId.toLowerCase()
    }

    if (path && id) {
      const url = `${environment.investorPrefix}${path}/${id}${secYieldPath}`
      this.navigateToUrl(url)
    }
  }

  isInvalidEtf(isEtf: boolean, url: string) {
    return isEtf && !ETF_REGEX.test(url)
  }

  isInvalidMf(isMf: boolean, url: string) {
    return isMf && !MF_REGEX.test(url)
  }

  isInvalid529(is529: boolean, url: string) {
    return is529 && !PLAN529_REGEX.test(url)
  }

  isInvalidPrettyUrl(response: ProfileResponse, url: string) {
    return (
      PRETTY_URL_REGEX.test(url) &&
      (this.isInvalidEtf(response.fundProfile.isETF, url) ||
        this.isInvalidMf(response.fundProfile.isMutualFund, url) ||
        this.isInvalid529(response.fundProfile.is529, url))
    )
  }

  navigateToUrl(url: string) {
    window.location.href = url
  }
}
